import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SADTForm, SADTItem } from '@project/view-models';
import { ApiService } from '@core/http';
import { environment } from '@env';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SessionDetailsSadtService {
  constructor(private apiService: ApiService) {}

  getSADTFormsviaPatientId(patientId: string): Observable<SADTItem[]> {
    const url = `${environment.environmentVariables.apiCoreUrl}/Sadt?PatientId=${patientId}&orderBy=created_at&direction=desc`;
    return this.apiService.get<SADTItem[]>(url);
  }

  getSADTFormsviaRequisitionId(requisitionId: string): Observable<SADTItem[]> {
    const url = `${environment.environmentVariables.apiCoreUrl}/Sadt?RequisitionId=${requisitionId}&orderBy=created_at&direction=desc`;
    return this.apiService.get<SADTItem[]>(url);
  }

  createSADTForm(SADTForm: SADTForm): Observable<void> {
    return this.apiService.post<void>(`${environment.environmentVariables.apiCoreUrl}/Sadt`, SADTForm);
  }

  downloadSadt(id: string): Observable<string> {
    return this.apiService.get(`${environment.environmentVariables.apiCoreUrl}/Sadt/${id}/Download`, {}, 'text').pipe(
      map((response: any) => {
        return response.toString();
      }),
      catchError((error) => {
        console.error('Error during download:', error);
        return throwError(() => new Error(error));
      }),
    );
  }
}
